<template>
  <div>
    <div class="section">
      <div class="container">
        <!-- Page Header -->
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Integrations', name: 'settings.integrations'}]" current="Utilities" :hideBack="true" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Shopify Utilities</h1>
          </div>
        </div>
        <!-- Content -->
        <div>
          <!-- Retry Orders (Merchants) -->
          <div v-if="context.isMerchant()" class="border-b mb-xl pb-xl">
            <RetryOrder :account="account" />
          </div>
          <!-- Retry Fulfillments (Suppliers) -->
          <div v-if="context.isSupplier()" class="border-b mb-xl pb-xl">
            <RetryFulfillment :account="account" />
          </div>
          <!-- Sync Inventory -->
          <div v-if="context.isMerchant()" class="border-b mb-xl pb-xl">
            <SyncInventory :account="account" />
          </div>
          <!-- Sync Inventory (Supplier) -->
          <div v-if="context.isSupplier()" class="border-b mb-xl pb-xl">
            <NewSyncInventory :account="account" />
          </div>
          <!-- Sync Variants By Vendor -->
          <div class="border-b mb-xl pb-xl">
            <SyncVariantsByVendor :account="account" />
          </div>
          <!-- Sync Variants By Date -->
          <div class="border-b mb-xl pb-xl">
            <SyncVariantsByDate :account="account" />
          </div>
          <!-- Sync Variants By Variant ID -->
          <div class="mb-xl pb-xl">
            <SyncVariantsByVariantId :account="account" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RetryOrder from '../components/ShopifyUtilities/RetryOrder'
import RetryFulfillment from '../components/ShopifyUtilities/RetryFulfillment'
import SyncInventory from '../components/ShopifyUtilities/SyncInventory'
import NewSyncInventory from '../components/ShopifyUtilities/NewSyncInventory'
import SyncVariantsByVendor from '../components/ShopifyUtilities/SyncVariantsByVendor'
import SyncVariantsByDate from '../components/ShopifyUtilities/SyncVariantsByDate'
import SyncVariantsByVariantId from '../components/ShopifyUtilities/SyncVariantsByVariantId'

export default {
  components: {
    RetryOrder,
    RetryFulfillment,
    SyncInventory,
    SyncVariantsByVendor,
    SyncVariantsByDate,
    SyncVariantsByVariantId,
    NewSyncInventory
  },
  data () {
    return {
      loading: true,
      account: null
    }
  },
  computed: {
    ...mapGetters(['auth', 'context']),
    endpoint () {
      return this.context.route + '/platform-accounts/' + this.$route.params.id + '/'
    }
  },
  methods: {
    load (refresh = false) {
      this.loading = (!refresh)
      this.$http.get(this.endpoint).then(response => {
        this.account = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.load()
  },
  props: []
}
</script>
